import type { ReactNode } from 'react'

interface ContainerProps {
  children: ReactNode
  className?: string
}

export default function Container({ children, className = '' }: ContainerProps) {
  return (
    <div className={`max-w-[1440px] mx-auto px-5 sm:px-8 md:px-10 lg:px-12 ${className}`}>
      {children}
    </div>
  )
}
